import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@wehunt/core-web'
import { useApiFetch } from '../../shared/api'

export interface EndedHuntDto {
  id: string
  huntName: string
  groupId: string
  groupName: string
  startTime: string
  endTime: string | null
  participantCount: number
  huntableGames: string[]
}

export interface EndedHuntsResponse {
  hunts: EndedHuntDto[]
}

export function useEndedHunts() {
  const call = useApiFetch()
  const { state } = useAuth()
  const uid = state.status === 'signed-in' ? state.user.uid : undefined
  return useQuery({
    queryKey: ['clubhouse', 'me', 'hunts', 'ended', uid],
    queryFn: () => call<EndedHuntsResponse>('/clubhouse/me/hunts/ended'),
    enabled: !!uid,
    staleTime: 60 * 1000,
  })
}
